/**
 * Pure H OS · Sprint 2 · Keyboard Shortcuts page.
 * Composes Card, SectionHeader, Kbd.
 */
import { Keyboard } from "lucide-react";
import { Card, SectionHeader } from "../components/lib";
import { Kbd } from "../components/lib.overlay";
import { KEYBOARD_SHORTCUTS } from "../mocks/platformData";

export default function Shortcuts() {
  const grouped = KEYBOARD_SHORTCUTS.reduce<Record<string, typeof KEYBOARD_SHORTCUTS>>((acc, s) => {
    (acc[s.category] = acc[s.category] || []).push(s);
    return acc;
  }, {});

  return (
    <div data-testid="pureh-shortcuts">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-[0.24em] text-slate-500 mb-2">Reference</div>
        <h1 className="text-3xl font-semibold text-slate-900 tracking-tight">Keyboard Shortcuts</h1>
        <div className="mt-1 text-sm text-slate-500">
          Every chord Pure H OS understands. Press <Kbd>⌘</Kbd><Kbd>/</Kbd> anywhere to summon this reference as a modal.
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {Object.entries(grouped).map(([cat, list]) => (
          <Card key={cat} testId={`shortcuts-group-${cat.toLowerCase()}`}>
            <SectionHeader eyebrow={cat} title={`${list.length} shortcut${list.length === 1 ? "" : "s"}`} action={<Keyboard size={14} style={{ color: "var(--ph-ink-muted)" }} />} />
            <div className="space-y-1">
              {list.map((s, i) => (
                <div
                  key={i}
                  className="flex items-center justify-between py-2 px-2"
                  data-testid={`shortcut-${s.keys.join("-")}`}
                  style={{ borderRadius: "var(--ph-radius-sm)" }}
                >
                  <div className="text-sm" style={{ color: "var(--ph-ink-strong)" }}>{s.label}</div>
                  <div className="flex items-center gap-1">
                    {s.keys.map((k, ki) => <Kbd key={ki}>{k}</Kbd>)}
                  </div>
                </div>
              ))}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
